import React, { useState } from 'react';
import { X } from 'lucide-react';

const NewProjectForm = ({ onSubmit, onClose, initialData }) => {
  const [formData, setFormData] = useState(initialData || {
    name: '',
    customer: '',
    customerAddress: '',
    customerPhone: '',
    type: 'residential',
    status: 'new',
    notes: ''
  });

  // Update formData if initialData changes (for editing existing projects)
  React.useEffect(() => {
    if (initialData) {
      setFormData(initialData);
    }
  }, [initialData]);

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('=== NEW PROJECT FORM DEBUG ===');
    console.log('Form data being submitted:', formData);
    console.log('customerAddress in formData:', formData.customerAddress);
    console.log('customerPhone in formData:', formData.customerPhone);
    onSubmit(formData);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-[var(--bg-secondary)] rounded-lg p-6 w-full max-w-md relative">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-[var(--text-secondary)] hover:text-[var(--text-primary)]"
        >
          <X size={20} />
        </button>
        
        <h2 className="text-2xl font-bold text-[var(--text-primary)] mb-6">{initialData ? 'Edit Project' : 'New Project'}</h2>
        
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label htmlFor="name" className="block text-sm font-medium text-[var(--text-secondary)] mb-1">
              Project Name*
            </label>
            <input
              type="text"
              id="name"
              required
              className="w-full px-3 py-2 rounded-lg border border-[var(--border-color)] bg-[var(--bg-primary)] text-[var(--text-primary)]"
              value={formData.name}
              onChange={(e) => setFormData(prev => ({ ...prev, name: e.target.value }))}
            />
          </div>

          <div>
            <label htmlFor="customer" className="block text-sm font-medium text-[var(--text-secondary)] mb-1">
              Customer Name*
            </label>
            <input
              type="text"
              id="customer"
              required
              className="w-full px-3 py-2 rounded-lg border border-[var(--border-color)] bg-[var(--bg-primary)] text-[var(--text-primary)]"
              value={formData.customer}
              onChange={(e) => setFormData(prev => ({ ...prev, customer: e.target.value }))}
            />
          </div>

          <div>
            <label htmlFor="customerAddress" className="block text-sm font-medium text-[var(--text-secondary)] mb-1">
              Customer Address
            </label>
            <input
              type="text"
              id="customerAddress"
              className="w-full px-3 py-2 rounded-lg border border-[var(--border-color)] bg-[var(--bg-primary)] text-[var(--text-primary)]"
              value={formData.customerAddress}
              onChange={(e) => setFormData(prev => ({ ...prev, customerAddress: e.target.value }))}
            />
          </div>

          <div>
            <label htmlFor="customerPhone" className="block text-sm font-medium text-[var(--text-secondary)] mb-1">
              Customer Phone
            </label>
            <input
              type="tel"
              id="customerPhone"
              className="w-full px-3 py-2 rounded-lg border border-[var(--border-color)] bg-[var(--bg-primary)] text-[var(--text-primary)]"
              value={formData.customerPhone}
              onChange={(e) => setFormData(prev => ({ ...prev, customerPhone: e.target.value }))}
            />
          </div>

          <div>
            <label htmlFor="type" className="block text-sm font-medium text-[var(--text-secondary)] mb-1">
              Project Type*
            </label>
            <select
              id="type"
              required
              className="w-full px-3 py-2 rounded-lg border border-[var(--border-color)] bg-[var(--bg-primary)] text-[var(--text-primary)]"
              value={formData.type}
              onChange={(e) => setFormData(prev => ({ ...prev, type: e.target.value }))}
            >
              <option value="residential">Residential</option>
              <option value="commercial">Commercial</option>
              <option value="industrial">Industrial</option>
            </select>
          </div>

          <div>
            <label htmlFor="notes" className="block text-sm font-medium text-[var(--text-secondary)] mb-1">
              Project Notes
            </label>
            <textarea
              id="notes"
              rows="4"
              className="w-full px-3 py-2 rounded-lg border border-[var(--border-color)] bg-[var(--bg-primary)] text-[var(--text-primary)] resize-none"
              placeholder="Add any general notes about this project..."
              value={formData.notes}
              onChange={(e) => setFormData(prev => ({ ...prev, notes: e.target.value }))}
            />
          </div>

          <div className="pt-4">
            <button
              type="submit"
              className="w-full btn btn-primary py-2 px-4 rounded-lg"
            >
              {initialData ? 'Save Changes' : 'Create Project'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default NewProjectForm; 